<script setup lang="ts">
import { App } from "@capacitor/app"
import { ConfigProvider } from "radix-vue"
import { Toaster } from "vue-sonner"
import { useTokenCookie } from "./composables/local/token-cookie"
import { useAiSocket } from "./composables/views/ai-socket"

const router = useRouter()
const ws = useAiSocket()
const login = useLogin()
const direction = useDirection()
// const pwa = usePwaUpdate()
const token = useTokenCookie()
const idProvider = () => useId() as any

const { public: { google, hotjarId } } = useRuntimeConfig()

direction.setDirection("rtl")

onMounted(() => {
	watch(login.isLogged, () => {
		if (login.isLogged.value) {
			ws.createSocket(token.getCookie()!)
			ws.open()
		}
		else {
			ws.close()
		}
	}, { immediate: true })

	/**
	 * Make MDC renderer client side, as we could not request every time
	 * a new chunk is recieved.
	 */
	window.sessionStorage.setItem("mdc-shiki-highlighter", "browser")

	if (import.meta.env.PROD) {
		useScriptGoogleAnalytics({ id: google.analyticsId })
		useScriptHotjar({ id: Number(hotjarId) })
		// pwa.checkForUpdates()
	}

	App.addListener("backButton", (event) => {
		if (!event.canGoBack) {
			App.minimizeApp()
		}
		else {
			router.back()
		}
	})
})
</script>

<template>
	<LoadingIndicator
		:height="4" />

	<!-- <VitePwaManifest /> -->

	<ConfigProvider
		:use-id="idProvider"
		:dir="direction.dir.value">
		<NuxtLayout>
			<NuxtPage />

			<ClientOnly>
				<Toaster
					theme="light"
					:dir="direction.dir.value"
					position="top-center" />
			</ClientOnly>
		</NuxtLayout>
	</ConfigProvider>
</template>
